import React, { useEffect, useRef, useState } from "react";
import { Input, Select, Modal, Button, Dropdown, message, Spin, Form } from "antd";
import {
    SearchOutlined,
    FilterOutlined,
    FolderFilled,
    FilePdfOutlined,
    FileWordOutlined,
    FileExcelOutlined,
    FileOutlined,
    DownloadOutlined,
    DeleteOutlined,
    ArrowLeftOutlined,
    EditOutlined
} from "@ant-design/icons";
import styled from "styled-components";
import * as pdfjsLib from "pdfjs-dist";
import { CALL_API, CALL_FEATCH_API } from "common/API";
import { useSelector } from "react-redux";
import { getUserInfo } from "redux/selectors";
import { jwtDecode } from "jwt-decode";
import { DropdownCheckBox } from "atoms/UIDropdown/Dropdown";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

pdfjsLib.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.mjs";

/* ── Styled ── */
const Toolbar = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
`;
const ListCount = styled.div`
    font-size: 14px;
    font-weight: 600;
    color: #111;
    display: flex;
    align-items: center;
    gap: 10px;
`;
const ToolbarRight = styled.div`
     display: flex;
  align-items: center;
  gap: 12px;

  .search-wrapper,
  .matter-wrapper {
    width: 160px;
    min-width: 180px;
  }
  .custom-filter-btn{
    margin-bottom: 0!important;
  }

  .search-wrapper .ant-input-affix-wrapper,
  .matter-wrapper {
    width: 100%;
  }
`;
const SearchBox = styled(Input)`
    width: 160px;
    border-radius: 20px !important;
    font-size: 13px;
    &:hover, &:focus { border-color: #2ecc71 !important; box-shadow: none !important; }
`;

const AddBtn = styled.div`
    background: #00685F;
    color: #ffffff;
    font-size: 15px;
    font-weight: 600;
    padding: 6px 18px;
    border-radius: 6px;
    cursor: pointer;
    white-space: nowrap;
    user-select: none;
    width: 150px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    &:hover { opacity: 0.85; }
    cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
`;
const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 16px;
    @media (max-width: 1100px) { grid-template-columns: repeat(4, 1fr); }
    @media (max-width: 800px)  { grid-template-columns: repeat(3, 1fr); }
`;
const Card = styled.div`
    border: 1px solid #efefef;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    transition: box-shadow 0.15s;
    &:hover { box-shadow: 0 2px 12px rgba(0,0,0,0.08); }
`;
const CardPreview = styled.div`
    height: 140px;
    background: #f7f7f7;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    position: relative;
    &:hover .overlay-actions { opacity: 1; }
`;
const CardLabel = styled.div`
    font-size: 12px;
    color: #333;
    padding: 8px 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    border-top: 1px solid #f0f0f0;
`;
const FolderIcon = styled(FolderFilled)`
    font-size: 72px;
    color: #f5a623;
`;
const VideoPlaceholder = styled.div`
    width: 100%;
    height: 100%;
    background: #e0e0e0;
    display: flex;
    align-items: center;
    justify-content: center;
    .play-icon {
        width: 40px; height: 40px; border-radius: 50%;
        background: #2ecc71; display: flex; align-items: center;
        justify-content: center; color: #fff; font-size: 16px;
    }
`;
const OverlayActions = styled.div`
    position: absolute;
    top: 8px; right: 8px;
    display: flex; gap: 6px;
    opacity: 0;
    transition: opacity 0.2s ease;
    z-index: 10;
    .icon {
        width: 28px; height: 28px; border-radius: 6px;
        background: #deefee; display: flex; align-items: center;
        justify-content: center; color: #00685F; cursor: pointer; font-size: 13px;
        &:hover { opacity: 0.8; }
    }
`;
const FolderInput = styled(Input)`
    border-radius: 6px !important; font-size: 14px; height: 44px;
    &:focus, &:hover { border-color: #2ecc71 !important; box-shadow: none !important; }
`;
const CancelBtn = styled(Button)`
    border-radius: 6px !important; height: 38px; font-size: 13px; padding: 0 20px; border-color: #000000 !important;
`;
const CreateBtn = styled(Button)`
    border-radius: 6px !important; height: 38px; font-size: 13px; padding: 0 20px;
    background: #00685F !important; border-color: #00685F !important; color: #ffffff !important;
    &:hover { opacity: 0.85; }
`;
const BackBtn = styled.div`
    display: flex; align-items: center; gap: 6px;
    font-size: 13px; color: #555; cursor: pointer;
    &:hover { color: #2ecc71; }
`;
const NoDataWrap = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 0 40px;
    color: #bbb;
    gap: 12px;
`;
const NoDataIcon = () => (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="8" y="16" width="48" height="36" rx="4" stroke="#d9d9d9" strokeWidth="2.5" fill="none" />
        <path d="M8 30h14l4 6h12l4-6h14" stroke="#d9d9d9" strokeWidth="2.5" strokeLinejoin="round" fill="none" />
        <path d="M22 16V10a2 2 0 012-2h16a2 2 0 012 2v6" stroke="#d9d9d9" strokeWidth="2.5" strokeLinejoin="round" fill="none" />
    </svg>
);
const EmptyState = ({ message: msg }) => (
    <NoDataWrap>
        <NoDataIcon />
        <span style={{ fontSize: 14, color: "#bbb" }}>{msg || "No data"}</span>
    </NoDataWrap>
);

/* ── Helpers ── */

// ✅ NEW: reliable MIME type resolver — file.type is empty for Excel on many browsers
const getMimeType = (file) => {
    if (file.type && file.type !== "application/octet-stream") return file.type;
    const ext = file.name.split(".").pop()?.toLowerCase();
    const mimeMap = {
        // Excel
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        xls: "application/vnd.ms-excel",
        csv: "text/csv",
        // Word
        docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        doc: "application/msword",
        // PowerPoint
        pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        ppt: "application/vnd.ms-powerpoint",
        // Others
        pdf: "application/pdf",
        jpg: "image/jpeg",
        jpeg: "image/jpeg",
        png: "image/png",
        gif: "image/gif",
        webp: "image/webp",
        svg: "image/svg+xml",
        mp4: "video/mp4",
        mov: "video/quicktime",
        avi: "video/x-msvideo",
        mkv: "video/x-matroska",
        webm: "video/webm",
    };
    return mimeMap[ext] || "application/octet-stream";
};

const getFileType = (name = "") => {
    const ext = name.split(".").pop()?.toLowerCase();
    if (["jpg", "jpeg", "png", "gif", "webp", "img", "bmp", "svg"].includes(ext)) return "image";
    if (["mp4", "avi", "mov", "mkv", "webm"].includes(ext)) return "video";
    if (ext === "pdf") return "pdf";
    if (["doc", "docx"].includes(ext)) return "word";
    if (["xls", "xlsx", "csv"].includes(ext)) return "excel";
    if (["ppt", "pptx"].includes(ext)) return "ppt";
    return "file";
};

const getFileTypeInfo = (type) => {
    switch (type) {
        case "pdf": return { bgColor: "#ff4d4f", label: "PDF", icon: <FilePdfOutlined style={{ fontSize: 48, color: "#fff" }} /> };
        case "word": return { bgColor: "#1890ff", label: "WORD", icon: <FileWordOutlined style={{ fontSize: 48, color: "#fff" }} /> };
        case "excel": return { bgColor: "#217346", label: "EXCEL", icon: <FileExcelOutlined style={{ fontSize: 48, color: "#fff" }} /> };
        case "ppt": return { bgColor: "#ff7a45", label: "PPT", icon: <FileOutlined style={{ fontSize: 48, color: "#fff" }} /> };
        case "video": return { bgColor: "#595959", label: "VIDEO", icon: null };
        default: return { bgColor: "#8c8c8c", label: "FILE", icon: <FileOutlined style={{ fontSize: 48, color: "#fff" }} /> };
    }
};

const isOfficeType = (type) => ["word", "ppt", "excel"].includes(type);

const generateThumbnail = async (file) => {
    const fileType = getFileType(file.name);
    if (fileType === "image") {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = (e) => resolve(e.target.result);
            reader.readAsDataURL(file);
        });
    }
    if (fileType === "pdf") {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = async (e) => {
                try {
                    const typedArray = new Uint8Array(e.target.result);
                    const pdf = await pdfjsLib.getDocument({ data: typedArray }).promise;
                    const page = await pdf.getPage(1);
                    const viewport = page.getViewport({ scale: 1.5 });
                    const canvas = document.createElement("canvas");
                    canvas.width = viewport.width;
                    canvas.height = viewport.height;
                    await page.render({ canvasContext: canvas.getContext("2d"), viewport }).promise;
                    resolve(canvas.toDataURL("image/png"));
                } catch { resolve(null); }
            };
            reader.readAsArrayBuffer(file);
        });
    }
    if (fileType === "video") {
        return new Promise((resolve) => {
            const url = URL.createObjectURL(file);
            const video = document.createElement("video");
            video.src = url; video.crossOrigin = "anonymous";
            video.currentTime = 0.5; video.muted = true;
            video.onloadeddata = () => {
                const canvas = document.createElement("canvas");
                canvas.width = video.videoWidth; canvas.height = video.videoHeight;
                canvas.getContext("2d").drawImage(video, 0, 0);
                URL.revokeObjectURL(url);
                resolve(canvas.toDataURL("image/png"));
            };
            video.onerror = () => { URL.revokeObjectURL(url); resolve(null); };
        });
    }
    return null;
};

// ── CsvThumbnail: fetches CSV and renders a mini table preview ──
const CsvThumbnail = ({ docId, clientIdFromToken, isMatter }) => {
    const [rows, setRows] = useState(null);

    useEffect(() => {
        if (!docId) return;
        let cancelled = false;
        const load = async () => {
            try {
                const res = await CALL_API(
                    `document-list/${clientIdFromToken}`,
                    "post",
                    {
                        method: isMatter ? "preview-matter-document" : "preview-client-document",
                        documentId: docId,
                    }
                );
                const url = res?.url || res?.data?.url || res?.response?.url;
                if (!url || cancelled) return;
                const resp = await fetch(url, { mode: "cors", cache: "no-store" });
                const text = await resp.text();
                const lines = text.trim().split("\n").slice(0, 6);
                const parsed = lines.map(l => l.split(",").slice(0, 5).map(c => c.replace(/^"|"$/g, "").trim()));
                if (!cancelled) setRows(parsed);
            } catch { }
        };
        load();
        return () => { cancelled = true; };
    }, [docId]);

    if (!rows) {
        return (
            <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", background: "#f7f7f7" }}>
                <Spin size="small" />
            </div>
        );
    }

    const headers = rows[0] || [];
    const dataRows = rows.slice(1);

    return (
        <div style={{ width: "100%", height: "100%", overflow: "hidden", background: "#fff", padding: "6px", boxSizing: "border-box" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 9, tableLayout: "fixed" }}>
                <thead>
                    <tr style={{ background: "#217346" }}>
                        {headers.map((h, i) => (
                            <th key={i} style={{ color: "#fff", padding: "2px 4px", fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 60 }}>{h}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {dataRows.map((row, ri) => (
                        <tr key={ri} style={{ background: ri % 2 === 0 ? "#f2f9f5" : "#fff" }}>
                            {row.map((cell, ci) => (
                                <td key={ci} style={{ padding: "2px 4px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", color: "#333", borderBottom: "1px solid #e8e8e8" }}>{cell}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

// ── COMPLETE REPLACEMENT for PdfThumbnail ──
// Strategy: Use XMLHttpRequest (not fetch) which handles S3 CORS presigned URLs better,
// with multiple fallback approaches
const PdfThumbnail = ({ docId, clientIdFromToken, isMatter }) => {
    const canvasRef = useRef(null);
    const [status, setStatus] = useState("loading"); // "loading" | "done" | "failed"

    useEffect(() => {
        if (!docId || docId?.toString().startsWith("uploading-")) return;
        let cancelled = false;

        const renderPdf = async (pdfData) => {
            try {
                const loadingTask = pdfjsLib.getDocument({
                    data: pdfData,
                    cMapUrl: `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/cmaps/`,
                    cMapPacked: true,
                    verbosity: 0,
                });

                const pdf = await loadingTask.promise;
                if (cancelled) return;

                const page = await pdf.getPage(1);
                if (cancelled) return;

                const canvas = canvasRef.current;
                if (!canvas) return;

                const desiredWidth = 220; // card width approx
                const unscaled = page.getViewport({ scale: 1 });
                const scale = desiredWidth / unscaled.width;
                const viewport = page.getViewport({ scale });

                canvas.width = viewport.width;
                canvas.height = viewport.height;

                const ctx = canvas.getContext("2d");
                ctx.fillStyle = "#ffffff";
                ctx.fillRect(0, 0, canvas.width, canvas.height);

                await page.render({ canvasContext: ctx, viewport }).promise;

                if (!cancelled) setStatus("done");
            } catch (err) {
                console.warn("pdf.js render error:", err);
                if (!cancelled) setStatus("failed");
            }
        };

        const loadViaXHR = (url) =>
            new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest();
                xhr.open("GET", url, true);
                xhr.responseType = "arraybuffer";
                // Don't set any headers — let the presigned URL handle auth
                xhr.onload = () => {
                    if (xhr.status === 200) {
                        resolve(new Uint8Array(xhr.response));
                    } else {
                        reject(new Error(`XHR failed: ${xhr.status}`));
                    }
                };
                xhr.onerror = () => reject(new Error("XHR network error"));
                xhr.ontimeout = () => reject(new Error("XHR timeout"));
                xhr.timeout = 30000;
                xhr.send();
            });

        const loadViaFetch = async (url) => {
            const resp = await fetch(url, {
                method: "GET",
                mode: "cors",
                cache: "no-store",
            });
            if (!resp.ok) throw new Error(`fetch failed: ${resp.status}`);
            const buf = await resp.arrayBuffer();
            return new Uint8Array(buf);
        };

        const main = async () => {
            try {
                // 1. Get fresh presigned URL from your API
                const res = await CALL_API(
                    `document-list/${clientIdFromToken}`,
                    "post",
                    {
                        method: isMatter
                            ? "preview-matter-document"
                            : "preview-client-document",
                        documentId: docId,
                    }
                );
                const url = res?.url || res?.data?.url || res?.response?.url;
                if (!url || cancelled) return;

                // 2. Try XHR first (handles S3 CORS better than fetch in some browsers)
                let pdfData = null;
                try {
                    pdfData = await loadViaXHR(url);
                } catch (xhrErr) {
                    console.warn("XHR failed, trying fetch:", xhrErr.message);
                    try {
                        pdfData = await loadViaFetch(url);
                    } catch (fetchErr) {
                        console.warn("fetch also failed:", fetchErr.message);
                        // 3. Last resort: pass URL directly to pdf.js
                        // pdf.js uses its own internal XHR which may succeed
                        try {
                            const loadingTask = pdfjsLib.getDocument({
                                url,
                                withCredentials: false,
                                cMapUrl: `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/cmaps/`,
                                cMapPacked: true,
                                verbosity: 0,
                            });
                            const pdf = await loadingTask.promise;
                            if (cancelled) return;
                            const page = await pdf.getPage(1);
                            if (cancelled) return;
                            const canvas = canvasRef.current;
                            if (!canvas) return;
                            const vp = page.getViewport({ scale: 1.2 });
                            canvas.width = vp.width;
                            canvas.height = vp.height;
                            const ctx = canvas.getContext("2d");
                            ctx.fillStyle = "#ffffff";
                            ctx.fillRect(0, 0, canvas.width, canvas.height);
                            await page.render({ canvasContext: ctx, viewport: vp }).promise;
                            if (!cancelled) setStatus("done");
                        } catch {
                            if (!cancelled) setStatus("failed");
                        }
                        return;
                    }
                }

                if (cancelled) return;
                if (pdfData) await renderPdf(pdfData);

            } catch (err) {
                console.error("PdfThumbnail fatal error:", err);
                if (!cancelled) setStatus("failed");
            }
        };

        main();
        return () => { cancelled = true; };
    }, [docId]);

    // If all methods fail, show the red PDF icon fallback
    if (status === "failed") {
        return (
            <div style={{
                width: "100%", height: "100%",
                display: "flex", flexDirection: "column",
                alignItems: "center", justifyContent: "center",
                background: "#ff4d4f",
            }}>
                <FilePdfOutlined style={{ fontSize: 48, color: "#fff" }} />
                <span style={{ color: "#fff", fontWeight: 600, fontSize: 13, marginTop: 6 }}>PDF</span>
            </div>
        );
    }

    return (
        <div style={{ width: "100%", height: "100%", position: "relative", background: "#fff" }}>
            {status === "loading" && (
                <div style={{
                    position: "absolute", inset: 0,
                    display: "flex", flexDirection: "column",
                    alignItems: "center", justifyContent: "center",
                    background: "#f7f7f7", gap: 6,
                }}>
                    <Spin size="small" />
                    <span style={{ fontSize: 10, color: "#aaa" }}>Loading preview...</span>
                </div>
            )}
            <canvas
                ref={canvasRef}
                style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    display: status === "done" ? "block" : "none",
                }}
            />
        </div>
    );
};

const FilePreview = ({ doc, onDownload, onDelete, onEdit, isMatterDoc, clientIdFromToken, isMatter }) => {
    const { type, previewUrl, name, loading } = doc;
    const fileInfo = getFileTypeInfo(type);

    const renderContent = () => {
        if (loading) {
            return (
                <div style={{
                    width: "100%", height: "100%", display: "flex", flexDirection: "column",
                    alignItems: "center", justifyContent: "center",
                    background: "#f0fdf8", gap: 8,
                }}>
                    <Spin size="small" />
                    <span style={{ fontSize: 11, color: "#aaa" }}>Uploading...</span>
                </div>
            );
        }

        if (type === "folder") return <FolderIcon />;

        if (type === "image" && previewUrl) {
            return (
                <img
                    src={previewUrl}
                    alt={name}
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                    onError={(e) => { e.target.style.display = "none"; }}
                />
            );
        }

        // ✅ PDF — always render fresh via PdfThumbnail (never use cached previewUrl for PDF)
        if (type === "pdf") {
            if (!doc.id || doc.id?.toString().startsWith("uploading-")) {
                // Still uploading — show spinner
                return (
                    <div style={{
                        width: "100%", height: "100%",
                        display: "flex", alignItems: "center", justifyContent: "center",
                        background: "#f7f7f7",
                    }}>
                        <Spin size="small" />
                    </div>
                );
            }
            return (
                <PdfThumbnail
                    docId={doc.id}
                    clientIdFromToken={clientIdFromToken}
                    isMatter={isMatter}
                />
            );
        }

        const ext = name?.split(".").pop()?.toLowerCase();

        if (type === "excel" && ext === "csv") {
            return (
                <CsvThumbnail
                    docId={doc.id}
                    clientIdFromToken={clientIdFromToken}
                    isMatter={isMatter}
                />
            );
        }

        if (isOfficeType(type) && previewUrl && ext !== "csv") {
            const viewerUrl = (type === "excel")
                ? `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(previewUrl)}`
                : `https://docs.google.com/viewer?embedded=true&url=${encodeURIComponent(previewUrl)}`;
            return (
                <div style={{ width: "100%", height: "140px", overflow: "hidden", position: "relative", backgroundColor: "#f5f5f5" }}>
                    <iframe
                        src={viewerUrl}
                        style={{
                            border: "none",
                            pointerEvents: "none",
                            transform: "scale(0.35)",
                            transformOrigin: "top left",
                            width: "285%",
                            height: "400px",
                            overflow: "hidden",
                        }}
                        scrolling="no"
                        title={name}
                    />
                </div>
            );
        }

        if (type === "video") {
            return (
                <VideoPlaceholder>
                    <div className="play-icon">▶</div>
                </VideoPlaceholder>
            );
        }

        return (
            <div style={{
                width: "100%", height: "100%",
                display: "flex", flexDirection: "column",
                alignItems: "center", justifyContent: "center",
                background: fileInfo.bgColor,
            }}>
                {fileInfo.icon}
                <span style={{ color: "#fff", fontWeight: 600, fontSize: 13, marginTop: 6, textTransform: "uppercase" }}>
                    {fileInfo.label}
                </span>
            </div>
        );
    };

    return (
        <CardPreview>
            {renderContent()}
            {!loading && type !== "folder" && (
                <OverlayActions className="overlay-actions">
                    <div className="icon" onClick={(e) => { e.stopPropagation(); onDownload?.(); }}>
                        <DownloadOutlined />
                    </div>
                    {/* {!isMatterDoc && ( */}
                    <div className="icon" onClick={(e) => { e.stopPropagation(); onDelete?.(); }}>
                        <DeleteOutlined />
                    </div>
                    {/* )} */}
                </OverlayActions>
            )}
            {!loading && type === "folder" && (
                <OverlayActions className="overlay-actions">
                    <div className="icon" onClick={(e) => { e.stopPropagation(); onEdit?.(); }}>
                        <span style={{ fontSize: 13, lineHeight: 1 }}><EditOutlined /></span>
                    </div>
                    <div className="icon" onClick={(e) => { e.stopPropagation(); onDelete?.(); }}>
                        <DeleteOutlined />
                    </div>
                </OverlayActions>
            )}
        </CardPreview>
    );
};

const CsvModalPreview = ({ url }) => {
    const [rows, setRows] = useState(null);
    const [error, setError] = useState(false);

    useEffect(() => {
        if (!url) return;
        fetch(url, { mode: "cors", cache: "no-store" })
            .then(r => r.text())
            .then(text => {
                const lines = text.trim().split("\n").slice(0, 50);
                const parsed = lines.map(l => l.split(",").map(c => c.replace(/^"|"$/g, "").trim()));
                setRows(parsed);
            })
            .catch(() => setError(true));
    }, [url]);

    if (error) return (
        <div style={{ textAlign: "center", color: "#888", padding: 40 }}>
            Cannot preview CSV — please download the file instead.
        </div>
    );

    if (!rows) return (
        <div style={{ display: "flex", justifyContent: "center", padding: 60 }}>
            <Spin size="large" />
        </div>
    );

    const headers = rows[0] || [];
    const dataRows = rows.slice(1);

    return (
        <div style={{ overflowX: "auto", maxHeight: 560, overflowY: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
                <thead style={{ position: "sticky", top: 0 }}>
                    <tr style={{ background: "#217346" }}>
                        {headers.map((h, i) => (
                            <th key={i} style={{ color: "#fff", padding: "8px 12px", fontWeight: 600, textAlign: "left", whiteSpace: "nowrap", borderRight: "1px solid #1a5c38" }}>{h}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {dataRows.map((row, ri) => (
                        <tr key={ri} style={{ background: ri % 2 === 0 ? "#f2f9f5" : "#fff" }}>
                            {row.map((cell, ci) => (
                                <td key={ci} style={{ padding: "6px 12px", borderBottom: "1px solid #e8e8e8", borderRight: "1px solid #f0f0f0", color: "#333", whiteSpace: "nowrap" }}>{cell}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

const PreviewModalContent = ({ doc, clientIdFromToken, isMatter }) => {
    const [url, setUrl] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const load = async () => {
            try {
                const res = await CALL_API(
                    `document-list/${clientIdFromToken}`,
                    "post",
                    { method: isMatter ? "preview-matter-document" : "preview-client-document", documentId: doc.id }
                );
                const fileUrl = res?.url || res?.data?.url || res?.response?.url;
                setUrl(fileUrl);
            } catch {
                message.error("Failed to load preview");
            } finally {
                setLoading(false);
            }
        };
        load();
    }, [doc.id]);

    if (loading) return (
        <div style={{ display: "flex", justifyContent: "center", padding: 60 }}>
            <Spin size="large" />
        </div>
    );

    if (!url) return (
        <div style={{ textAlign: "center", color: "#bbb", padding: 40 }}>
            Preview not available
        </div>
    );

    const type = doc.type;

    if (type === "image") return (
        <img src={url} alt={doc.name} style={{ width: "100%", maxHeight: 600, objectFit: "contain" }} />
    );

    if (type === "pdf") return (
        <iframe src={url} style={{ width: "100%", height: 600, border: "none" }} title={doc.name} />
    );

    const docExt = doc.name?.split(".").pop()?.toLowerCase();

    if (type === "excel" && docExt === "csv") return (
        <CsvModalPreview url={url} />
    );

    if (isOfficeType(type)) return (
        <iframe
            src={type === "excel"
                ? `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`
                : `https://docs.google.com/viewer?embedded=true&url=${encodeURIComponent(url)}`}
            style={{ width: "100%", height: 600, border: "none" }}
            title={doc.name}
        />
    );

    if (type === "video") return (
        <video src={url} controls style={{ width: "100%", maxHeight: 600 }} />
    );

    return (
        <div style={{ textAlign: "center", color: "#888", padding: 40 }}>
            No preview available for this file type.
        </div>
    );
};

const DocumentTab = ({ clientId, matterId, activeTab }) => {
    const [form] = Form.useForm();
    const [docs, setDocs] = useState([]);
    const [search, setSearch] = useState("");
    const [folderModalOpen, setFolderModalOpen] = useState(false);
    const [folderName, setFolderName] = useState("");
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [uploadingIds, setUploadingIds] = useState(new Set());
    const [openFolderId, setOpenFolderId] = useState(null);
    const [openFolderDocId, setOpenFolderDocId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [matters, setMatters] = useState([]);
    const [selectedMatter, setSelectedMatter] = useState(null);
    const [previewDoc, setPreviewDoc] = useState(null);
    const [editFolderModalOpen, setEditFolderModalOpen] = useState(false);
    const [editFolderRecord, setEditFolderRecord] = useState(null);
    const [editFolderName, setEditFolderName] = useState("");
    const token = window.localStorage.getItem("token");
    const clientIdFromToken = jwtDecode(token)?.clientId;

    const isMatter = !!matterId;
    const entityId = isMatter ? matterId : clientId;
    const location = useLocation();
    const clientIdForMatterDocument = location?.state?.matterData?.clientId || "";
    const isClosed = location?.state?.matterData?.matterStatus === "Closed";
    const userinfo = useSelector(getUserInfo);
    const fileInputRef = useRef();
    const wasActiveRef = useRef(false);

    useEffect(() => {
        fetchDocuments(null, null);
        fetchMatters();
        return () => {
            setOpenFolderId(null);
            setOpenFolderDocId(null);
            setSearch("");
        };
    }, []);

    useEffect(() => {
        const isDoc = activeTab === "document";
        if (isDoc && !wasActiveRef.current) {
            setOpenFolderId(null);
            setOpenFolderDocId(null);
            setSearch("");
            fetchDocuments(null, null);
        }
        wasActiveRef.current = isDoc;
    }, [activeTab]); // eslint-disable-line react-hooks/exhaustive-deps

    const currentDocs = openFolderId
        ? (docs.find((d) => d.id === openFolderId)?.files || [])
        : docs;

    const filtered = currentDocs?.filter((d) => {
        const matchesSearch = d.name
            ?.toLowerCase()
            ?.includes(search?.toLowerCase());
        const matchesMatter =
            !selectedMatter ||
            d.matterid === selectedMatter ||
            d.doc_source_id === selectedMatter;

        return matchesSearch && matchesMatter;
    });

    const openFolder = docs?.find((d) => d?.id === openFolderId);

    const loadAndSetPreview = async (doc, folderId = null) => {
        // PDFs now self-render via PdfThumbnail — nothing to preload
        if (!["image", "word", "ppt", "excel"].includes(doc.type)) return;
        if (!doc.id) return;

        try {
            const res = await CALL_API(
                `document-list/${clientIdFromToken}`,
                "post",
                { method: isMatter ? "preview-matter-document" : "preview-client-document", documentId: doc.id }
            );
            const url = res?.url || res?.data?.url || res?.response?.url;
            if (!url) return;

            // For images, use URL directly (presigned URLs work fine as <img src>)
            const previewUrl = url;

            const patchDocs = (prev) =>
                folderId
                    ? prev.map((d) =>
                        d.id === folderId
                            ? { ...d, files: (d.files || []).map((f) => f.id === doc.id ? { ...f, previewUrl } : f) }
                            : d
                    )
                    : prev.map((d) => d.id === doc.id ? { ...d, previewUrl } : d);

            setDocs(patchDocs);
        } catch {
            // silently skip
        }
    };

    const fetchDocuments = async (folderId, folderDocId) => {
        try {
            setLoading(true);
            const query = isMatter
                ? `insyts-matter/getmatterdocument?matterid=${entityId}${folderDocId ? `&folderid=${folderDocId}` : ""}`
                : `/insyts-legal/getdocument?clientid=${entityId}${folderDocId ? `&folderid=${folderDocId}` : ""}`;

            const res = await CALL_FEATCH_API(query, "get");

            if (folderDocId) {
                // ── Inside a folder ──
                const data = isMatter
                    ? (res?.response?.matterdata || res?.response?.data || [])
                    : [
                        ...(res?.response?.clientdata || []),
                        ...(res?.response?.matterdata || []),
                    ];

                const folderFiles = data.map((item) => ({
                    id: item.docid,
                    name: item.docname,
                    type: getFileType(item.docname),
                    previewUrl: null,
                    loading: false,
                    objectkey: item.objectkey,
                    doctype: item.doctype,
                    docsize: item.docsize,
                    createdby: item.createdby,
                    createdat: item.createdat,
                    folderid: item.folderid,
                    matterid: String(item.matterid || ""),
                    doc_source_id: String(item.matterid || ""),
                    doc_source: item.matterid ? "matter" : "client",
                }));

                setDocs((prev) =>
                    prev.map((d) => d.id === folderId ? { ...d, files: folderFiles } : d)
                );

                folderFiles.forEach((doc) => loadAndSetPreview(doc, folderId));
            } else {
                // ── Root level ──
                let allFiles = [];
                let allFolders = [];

                if (isMatter) {
                    allFiles = res?.response?.matterdata || res?.response?.data || [];
                    allFolders = res?.response?.matterfolder || res?.response?.folder || [];
                    // Matter page: all files are matter docs
                    allFiles = allFiles.map(f => ({ ...f, doc_source: "matter" }));
                } else {
                    // :white_check_mark: Tag each file with its source BEFORE merging
                    const clientFiles = (res?.response?.clientdata || []).map(f => ({ ...f, doc_source: "client" }));
                    const matterFiles = (res?.response?.matterdata || []).map(f => ({ ...f, doc_source: "matter" }));
                    const clientFolders = (res?.response?.clientfolder || []).map(f => ({ ...f, doc_source: "client" }));
                    const matterFolders = (res?.response?.matterfolder || []).map(f => ({ ...f, doc_source: "matter" }));

                    allFiles = [...clientFiles, ...matterFiles];
                    allFolders = [...clientFolders, ...matterFolders];
                }

                const mappedFolders = allFolders.map((f) => {
                    const preloadedFiles = (f.documents || []).map((item) => ({
                        id: item.docid,
                        name: item.docname,
                        type: getFileType(item.docname),
                        previewUrl: null,
                        loading: false,
                        objectkey: item.objectkey,
                        doctype: item.doctype,
                        docsize: item.docsize,
                        createdby: item.createdby,
                        createdat: item.createdat,
                        folderid: item.folderid,
                        matterid: String(item.matterid || ""),
                        doc_source_id: String(item.matterid || ""),
                        // :white_check_mark: folder files inherit folder's doc_source
                        doc_source: f.doc_source,
                    }));

                    return {
                        id: `folder-${f.folderid}`,
                        folderid: f.folderid,
                        name: f.foldername,
                        type: "folder",
                        previewUrl: null,
                        loading: false,
                        files: preloadedFiles,
                        doc_source: f.doc_source,
                    };
                });

                const rootFiles = allFiles
                    .filter((item) => item.folderid === "0" || item.folderid === 0)
                    .map((item) => ({
                        id: item.docid,
                        name: item.docname,
                        type: getFileType(item.docname),
                        previewUrl: null,
                        loading: false,
                        objectkey: item.objectkey,
                        doctype: item.doctype,
                        docsize: item.docsize,
                        createdby: item.createdby,
                        createdat: item.createdat,
                        folderid: item.folderid,
                        // :white_check_mark: doc_source already tagged above before merging
                        doc_source: item.doc_source,
                        matterid: String(item.matterid || ""),
                        doc_source_id: String(item.matterid || ""),
                    }));

                setDocs((prev) => {
                    const localFolders = prev.filter(
                        (d) => d.type === "folder" && !mappedFolders.find((f) => f.id === d.id)
                    );
                    return [...mappedFolders, ...localFolders, ...rootFiles];
                });

                rootFiles.forEach((doc) => loadAndSetPreview(doc, null));
            }
        } catch (err) {
            console.error(err);
            message.error("Failed to fetch documents");
        } finally {
            setLoading(false);
        }
    };

    /* ── handleFileSelected ── */
    const handleFileSelected = async (e) => {
        const files = Array.from(e.target.files);
        if (!files?.length) return;
        const snapshotFolderId = openFolderId;
        const snapshotFolderDocId = openFolderDocId;

        const placeholders = files.map((file) => ({
            id: `uploading-${Date.now()}-${Math.random()}`,
            name: file.name,
            type: getFileType(file.name),
            previewUrl: null,
            loading: true,
            file,
        }));

        if (snapshotFolderId) {
            setDocs((prev) =>
                prev.map((d) =>
                    d.id === snapshotFolderId
                        ? { ...d, files: [...(d.files || []), ...placeholders] }
                        : d
                )
            );
        } else {
            setDocs((prev) => [...prev, ...placeholders]);
        }

        setUploadingIds(new Set(placeholders.map((p) => p.id)));

        placeholders.forEach(async (placeholder) => {
            const file = placeholder.file;

            // ✅ Resolve correct MIME type before any API calls
            const mimeType = getMimeType(file);

            try {
                // Step 1 — Get presigned URL from backend
                const fileRes = await CALL_API(
                    isMatter ? `insyts-matter/addmatterdocument?file` : `insyts-legal/adddocuments?file`,
                    "post",
                    { filenames: [file.name] }
                );

                const fileData = fileRes?.uploadFileData?.[0];
                if (!fileData?.presignedUrl || !fileData?.objectkey) {
                    throw new Error(fileRes?.message || "Presigned URL missing");
                }

                // Step 2 — Upload file to S3 with correct Content-Type
                // ✅ Use mimeType instead of file.type (which is empty for Excel on many browsers)
                const putRes = await fetch(fileData.presignedUrl, {
                    method: "PUT",
                    headers: { "Content-Type": mimeType },
                    body: file,
                });

                if (!putRes.ok) {
                    const errorText = await putRes.text();
                    throw new Error(`S3 upload failed (${putRes.status}): ${errorText}`);
                }

                // Step 3 — Generate local thumbnail
                const thumbnail = await generateThumbnail(file);

                const folderDocId = snapshotFolderDocId || 0;
                const objectKeyTimestamp = fileData.objectkey;

                // Step 4 — Save metadata to backend
                // ✅ Use mimeType for doctype as well
                const metaRes = await CALL_API(
                    isMatter ? "insyts-matter/addmatterdocument" : "/insyts-legal/adddocuments",
                    "post",
                    isMatter
                        ? {
                            docname: file.name,
                            folderid: folderDocId || 0,
                            docsize: String(file.size),
                            doctype: mimeType,       // ✅ fixed
                            createdby: userinfo?.userid,
                            objectkey: objectKeyTimestamp,
                            matterid: entityId,
                            clientid: clientIdForMatterDocument,
                        }
                        : {
                            docname: file.name,
                            folderid: folderDocId || 0,
                            docsize: String(file.size),
                            doctype: mimeType,       // ✅ fixed
                            createdby: userinfo?.userid,
                            objectkey: objectKeyTimestamp,
                            clientid: entityId,
                        }
                );

                if (!metaRes) throw new Error("Metadata save failed — empty response");

                const savedDocId = metaRes?.data?.id || placeholder.id;

                const finalDoc = {
                    id: savedDocId,
                    name: file.name,
                    type: getFileType(file.name),
                    previewUrl:
                        getFileType(file.name) === "image" || getFileType(file.name) === "pdf"
                            ? thumbnail
                            : isOfficeType(getFileType(file.name))
                                ? fileData.presignedUrl
                                : null,
                    loading: false,
                    file,
                    objectkey: fileData.objectkey,
                };

                if (snapshotFolderId) {
                    setDocs((prev) =>
                        prev.map((d) =>
                            d.id === snapshotFolderId
                                ? { ...d, files: d.files.map((f) => f.id === placeholder.id ? finalDoc : f) }
                                : d
                        )
                    );
                } else {
                    setDocs((prev) => prev.map((d) => d.id === placeholder.id ? finalDoc : d));
                }

                await loadAndSetPreview(
                    { id: savedDocId, name: file.name, type: getFileType(file.name) },
                    snapshotFolderId || null
                );

            } catch (err) {
                console.error("Upload error details:", err); // ✅ full error now visible
                message.error(`Upload failed for "${file.name}": ${err.message}`);
                if (snapshotFolderId) {
                    setDocs((prev) =>
                        prev.map((d) =>
                            d.id === snapshotFolderId
                                ? { ...d, files: d.files.filter((f) => f.id !== placeholder.id) }
                                : d
                        )
                    );
                } else {
                    setDocs((prev) => prev.filter((d) => d.id !== placeholder.id));
                }
            } finally {
                setUploadingIds((prev) => {
                    const next = new Set(prev);
                    next.delete(placeholder.id);
                    return next;
                });
                await fetchDocuments(snapshotFolderId, snapshotFolderDocId);
            }
        });

        if (fileInputRef.current) fileInputRef.current.value = "";
    };

    /* ── handleCreateFolder ── */
    const handleCreateFolder = async () => {
        if (!folderName.trim()) return;
        try {
            const res = await CALL_API(
                isMatter ? "insyts-matter/addmatterfolder" : "/insyts-legal/addfolder",
                "post",
                isMatter
                    ? { foldername: folderName.trim(), matterid: entityId, clientid: clientIdForMatterDocument }
                    : { foldername: folderName.trim(), clientid: entityId }
            );
            if (res?.folderid) {
                message.success("Folder created");
                await fetchDocuments(null, null);
            } else {
                message.error("Failed to create folder");
            }
        } catch (err) {
            console.error(err);
            message.error("Failed to create folder");
        } finally {
            setFolderName("");
            setFolderModalOpen(false);
        }
    };

    /* ── handleDownload ── */
    const handleDownload = async (doc) => {
        try {
            let fileUrl = null;
            let fileName = doc.name;

            if (doc.file) {
                const url = URL.createObjectURL(doc.file);
                const a = document.createElement("a");
                a.href = url;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
                return;
            }

            if (doc.id) {
                const res = await CALL_API(
                    `document-list/${clientIdFromToken}`,
                    "post",
                    { method: isMatter ? "preview-matter-document" : "preview-client-document", documentId: doc.id }
                );
                fileUrl = res?.url || res?.data?.url || res?.response?.url;
                if (!fileUrl) throw new Error("No file URL returned");
            }

            const blob = await fetch(fileUrl).then((r) => r.blob());
            const blobUrl = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = blobUrl;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(blobUrl);
        } catch (err) {
            console.error(err);
            message.error("Download failed");
        }
    };

    /* ── handleDelete ── */
    const handleDelete = (doc) => {
        Modal.confirm({
            content: "Are you sure you want to delete this file?",
            okText: "Yes",
            cancelText: "No",
            centered: true,
            icon: null,
            okButtonProps: {
                style: { background: "#c2fae5", borderColor: "#c2fae5", color: "#111", borderRadius: 8 },
            },
            cancelButtonProps: { style: { borderRadius: 8 } },
            onOk: async () => {
                try {
                    const res = await CALL_FEATCH_API(
                        isMatter ? "insyts-matter/deletematterdocument" : "/insyts-legal/deletedocument",
                        "delete",
                        {
                            docid: doc.id,
                            updatedby: userinfo?.userid || "",
                            ...(isMatter ? { matterid: entityId } : {}),
                        }
                    );
                    if (res?.code === "SUCCESS" || res?.status === "SUCCESS") {
                        if (openFolderId) {
                            setDocs((prev) =>
                                prev.map((d) =>
                                    d.id === openFolderId
                                        ? { ...d, files: d.files.filter((f) => f.id !== doc.id) }
                                        : d
                                )
                            );
                        } else {
                            setDocs((prev) => prev.filter((d) => d.id !== doc.id));
                        }
                        message.success("File deleted");
                        if (openFolderId) {
                            await fetchDocuments(openFolderId, openFolderDocId);
                        } else {
                            await fetchDocuments(null, null);
                        }
                    } else {
                        message.error("Delete failed");
                    }
                } catch (err) {
                    console.error(err);
                    message.error("Delete failed");
                }
            },
        });
    };

    /* ── handleCardClick ── */
    const handleCardClick = (doc) => {
        if (doc.type === "folder") {
            setOpenFolderId(doc.id);
            setOpenFolderDocId(doc.folderid);
            setSearch("");
            fetchDocuments(doc.id, doc.folderid);
        } else {
            setPreviewDoc(doc);
        }
    };

    /* ── handleBack ── */
    const handleBack = () => {
        setOpenFolderId(null);
        setOpenFolderDocId(null);
        setSearch("");
        fetchDocuments(null, null);
    };

    const handleEditFolder = (doc) => {
        setEditFolderRecord(doc);
        setEditFolderName(doc.name);
        setEditFolderModalOpen(true);
    };

    const handleEditFolderConfirm = async () => {
        if (!editFolderName.trim()) return;

        const isMatterFolder = editFolderRecord?.doc_source === "matter"; // ← check folder's source

        try {
            await CALL_API(
                isMatterFolder ? "insyts-matter/editmatterfolder" : "insyts-legal/editfolder",
                "post",
                {
                    folderid: editFolderRecord.folderid,
                    foldername: editFolderName.trim(),
                    ...(isMatterFolder ? { isMatterFolder: true } : { isClientFolder: true }),
                }
            );
            message.success("Folder renamed");
            setDocs((prev) =>
                prev.map((d) =>
                    d.id === editFolderRecord.id ? { ...d, name: editFolderName.trim() } : d
                )
            );
            await fetchDocuments(null, null);
            setEditFolderModalOpen(false);
            setEditFolderRecord(null);
            setEditFolderName("");
        } catch (err) {
            console.error(err);
            message.error("Failed to rename folder");
        }
    };

    const handleDeleteFolder = (doc) => {
        Modal.confirm({
            content: "Are you sure you want to delete this folder?",
            okText: "Yes",
            cancelText: "No",
            centered: true,
            icon: null,
            okButtonProps: {
                style: { background: "#c2fae5", borderColor: "#c2fae5", color: "#111", borderRadius: 8 },
            },
            cancelButtonProps: { style: { borderRadius: 8 } },
            onOk: async () => {
                try {
                    const isMatterFolder = doc.doc_source === "matter";
                    await CALL_API(
                        isMatter ? "insyts-matter/deletematterfolder" : "insyts-legal/deletefolder",
                        "post",
                        { folderid: doc.folderid, ...(isMatterFolder ? { isMatterFolder: true } : { isClientFolder: true }), }
                    );
                    message.success("Folder deleted");
                    setDocs((prev) => prev.filter((d) => d.id !== doc.id));
                    await fetchDocuments(null, null);
                } catch (err) {
                    console.error(err);
                    message.error("Failed to delete folder");
                }
            },
        });
    };

    const fetchMatters = async () => {
        try {
            const query = isMatter
                ? "insyts-matter/getallmatterlist"
                : `insyts-matter/getallmatterlist?clientid=${clientId}`;

            const res = await CALL_API(query, "get");

            setMatters(
                res?.data ||
                res?.response?.data ||
                []
            );
        } catch (e) {
            setMatters([]);
        }
    };

    const dropdownItems = {
        items: [
            {
                key: "document",
                label: <span style={{ fontSize: 14 }}>Document</span>,
                onClick: () => { setDropdownOpen(false); fileInputRef.current?.click(); },
            },
            ...(!openFolderId ? [{
                key: "folder",
                label: <span style={{ fontSize: 14 }}>Folder</span>,
                onClick: () => { setDropdownOpen(false); setFolderModalOpen(true); },
            }] : []),
        ],
    };

    /* ── Render ── */
    return (
        <div style={{ paddingTop: 20 }}>
            <input
                ref={fileInputRef}
                type="file"
                multiple
                accept="*/*"
                style={{ display: "none" }}
                onChange={handleFileSelected}
            />

            <Toolbar>
                <ListCount>
                    {openFolderId && (
                        <BackBtn onClick={handleBack}>
                            <ArrowLeftOutlined /> Back
                        </BackBtn>
                    )}
                    {openFolderId
                        ? <span>{openFolder?.name}</span>
                        : <span>List of Documents: {filtered?.length}</span>
                    }
                </ListCount>

                <ToolbarRight>
                    <div className="search-wrapper">
                        <SearchBox
                            placeholder="Search"
                            prefix={<SearchOutlined style={{ color: "#bbb" }} />}
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            allowClear
                        />
                    </div>

                    {!isMatter && !openFolderId && matters?.length > 0 && (
                        <div className="matter-wrapper">
                            <Form
                                form={form}
                                onValuesChange={(changedValues, allValues) => {
                                    if ("selectedMatter" in changedValues) {
                                        setSelectedMatter(
                                            allValues?.selectedMatter?.[0] || null
                                        );
                                    }
                                }}
                            >
                                <DropdownCheckBox
                                    style={{ marginBottom: 0 }}
                                    label="Matter"
                                    name="selectedMatter"
                                    form={form}
                                    options={matters.map((m) => ({
                                        label: m.name || m.mattername,
                                        value: m.id || m.matterid,
                                    }))}
                                />
                            </Form>
                        </div>
                    )}
                    <Dropdown
                        menu={dropdownItems}
                        trigger={isClosed ? [] : ["click"]}
                        open={isClosed ? false : dropdownOpen}
                        onOpenChange={(open) => {
                            if (!isClosed) {
                                setDropdownOpen(open);
                            }
                        }}
                        placement="bottomRight"
                    >
                        <span>
                            <AddBtn disabled={isClosed}>
                                Add +
                            </AddBtn>
                        </span>
                    </Dropdown>
                </ToolbarRight>
            </Toolbar>

            {loading ? (
                <div style={{ display: "flex", justifyContent: "center", paddingTop: 60 }}>
                    <Spin size="large" />
                </div>
            ) : (
                <>
                    {filtered?.length === 0 && (
                        <EmptyState
                            message={
                                openFolderId
                                    ? "This folder is empty. Click Add + to upload files."
                                    : "No documents yet. Click Add + to upload."
                            }
                        />
                    )}
                    <Grid>
                        {filtered?.map((doc) => (
                            <Card key={doc.id} onClick={() => handleCardClick(doc)}>
                                <FilePreview
                                    doc={doc}
                                    onDownload={() => handleDownload(doc)}
                                    onEdit={() => handleEditFolder(doc)}
                                    onDelete={() => doc.type === "folder" ? handleDeleteFolder(doc) : handleDelete(doc)}
                                    isMatterDoc={doc.doc_source === "matter"}
                                    clientIdFromToken={clientIdFromToken}   // ← add
                                    isMatter={isMatter}
                                />
                                <CardLabel title={doc.name}>{doc.name}</CardLabel>
                            </Card>
                        ))}
                    </Grid>
                </>
            )}

            <Modal
                open={folderModalOpen}
                onCancel={() => { setFolderModalOpen(false); setFolderName(""); }}
                title={<span style={{ fontSize: 16, fontWeight: 600 }}>Name the folder</span>}
                footer={null}
                width={560}
                centered
            >
                <FolderInput
                    value={folderName}
                    onChange={(e) => setFolderName(e.target.value)}
                    placeholder="Folder name"
                    onPressEnter={handleCreateFolder}
                    autoFocus
                />
                <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 24 }}>
                    <CancelBtn onClick={() => { setFolderModalOpen(false); setFolderName(""); }}>
                        Cancel
                    </CancelBtn>
                    <CreateBtn onClick={handleCreateFolder}>Create</CreateBtn>
                </div>
            </Modal>

            <Modal
                open={!!previewDoc}
                onCancel={() => setPreviewDoc(null)}
                footer={null}
                width={860}
                centered
                title={<span style={{ fontSize: 15, fontWeight: 600 }}>{previewDoc?.name}</span>}
                destroyOnClose
            >
                {previewDoc && (
                    <PreviewModalContent
                        doc={previewDoc}
                        clientIdFromToken={clientIdFromToken}
                        isMatter={isMatter}
                    />
                )}
            </Modal>
            <Modal
                open={editFolderModalOpen}
                onCancel={() => { setEditFolderModalOpen(false); setEditFolderName(""); }}
                title={<span style={{ fontSize: 16, fontWeight: 600 }}>Rename folder</span>}
                footer={null}
                width={560}
                centered
                destroyOnClose
            >
                <FolderInput
                    value={editFolderName}
                    onChange={(e) => setEditFolderName(e.target.value)}
                    placeholder="Folder name"
                    onPressEnter={handleEditFolderConfirm}
                    autoFocus
                />
                <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 24 }}>
                    <CancelBtn onClick={() => { setEditFolderModalOpen(false); setEditFolderName(""); }}>
                        Cancel
                    </CancelBtn>
                    <CreateBtn onClick={handleEditFolderConfirm}>Save</CreateBtn>
                </div>
            </Modal>
        </div>
    );
};

export default DocumentTab;